// UX41: counter + upgrade-prompt gate for the ephemeral-vote flow.
//
// A user who votes without signing in gets a key auto-generated by
// useNostrLogin.beginEphemeral(). This util tracks how many votes
// that key has signed so the UI can offer to save with Google at
// the right moment (default: vote #3) without nagging on every
// subsequent click.
//
// Snooze behavior: if the user dismisses the prompt, we record the
// vote count at which they dismissed. The prompt won't show again
// until they've cast UPGRADE_PROMPT_SNOOZE_VOTES more votes. Prevents
// a nag loop while still re-offering at a sensible cadence.

import {
  LS_EPHEMERAL_VOTES,
  LS_UPGRADE_PROMPT,
  UPGRADE_PROMPT_THRESHOLD,
  UPGRADE_PROMPT_SNOOZE_VOTES,
} from './constants.js'

export function loadEphemeralVoteCount() {
  try {
    const raw = localStorage.getItem(LS_EPHEMERAL_VOTES)
    const n = Number(raw)
    return Number.isInteger(n) && n >= 0 ? n : 0
  } catch { return 0 }
}

export function incrementEphemeralVoteCount() {
  const next = loadEphemeralVoteCount() + 1
  try { localStorage.setItem(LS_EPHEMERAL_VOTES, String(next)) } catch { /* noop */ }
  return next
}

export function clearEphemeralVoteState() {
  try {
    localStorage.removeItem(LS_EPHEMERAL_VOTES)
    localStorage.removeItem(LS_UPGRADE_PROMPT)
  } catch { /* noop */ }
}

export function shouldShowUpgradePrompt(voteCount) {
  if (voteCount < UPGRADE_PROMPT_THRESHOLD) return false
  try {
    const raw = localStorage.getItem(LS_UPGRADE_PROMPT)
    if (!raw) return voteCount === UPGRADE_PROMPT_THRESHOLD
    const parsed = JSON.parse(raw)
    const dismissedAtVote = Number(parsed?.dismissedAtVote)
    if (!Number.isInteger(dismissedAtVote)) {
      return voteCount === UPGRADE_PROMPT_THRESHOLD
    }
    return voteCount >= dismissedAtVote + UPGRADE_PROMPT_SNOOZE_VOTES
  } catch {
    return voteCount === UPGRADE_PROMPT_THRESHOLD
  }
}

export function snoozeUpgradePrompt(currentVoteCount) {
  try {
    localStorage.setItem(LS_UPGRADE_PROMPT, JSON.stringify({
      dismissedAtVote: currentVoteCount,
    }))
  } catch { /* noop */ }
}
